import { useSyncExternalStore, useCallback, useMemo } from 'react';

// useFavorites — preferiti "pinnabili" delle funzioni più usate (★).
// Persistenza per-dispositivo in localStorage. Nessun dato server, nessuna
// chiamata: è solo una scorciatoia UI (le route restano le stesse).
//
// STORE CONDIVISO a livello di modulo (React useSyncExternalStore): TUTTI i
// consumatori nella stessa pagina (barra Preferiti nel Layout + ★ sulle card
// delle Hub) condividono lo stesso stato e si aggiornano INSIEME quando si
// pinna/spinna. L'evento `storage` copre in più la sincronizzazione fra tab.
const KEY = 'nav_favorites';
const listeners = new Set();

function readRaw() {
  try { return localStorage.getItem(KEY) || '[]'; } catch { return '[]'; }
}

// Snapshot = stringa JSON grezza (primitivo stabile → niente loop in
// useSyncExternalStore; il Set si deriva a valle con useMemo).
let snapshot = readRaw();

function emit() { listeners.forEach((l) => l()); }

function subscribe(cb) {
  listeners.add(cb);
  const onStorage = (e) => {
    if (e.key === KEY) { snapshot = readRaw(); cb(); }
  };
  window.addEventListener('storage', onStorage);
  return () => { listeners.delete(cb); window.removeEventListener('storage', onStorage); };
}

function getSnapshot() { return snapshot; }

function writeFavorites(arr) {
  const raw = JSON.stringify(arr);
  try { localStorage.setItem(KEY, raw); } catch { /* noop */ }
  snapshot = raw;          // aggiorna lo snapshot condiviso
  emit();                  // notifica i consumatori nella stessa pagina
}

export function useFavorites() {
  const raw = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  const favorites = useMemo(() => {
    try { return new Set(JSON.parse(raw)); } catch { return new Set(); }
  }, [raw]);

  const toggle = useCallback((route) => {
    let next;
    try { next = new Set(JSON.parse(readRaw())); } catch { next = new Set(); }
    if (next.has(route)) next.delete(route); else next.add(route);
    writeFavorites([...next]);
  }, []);

  const has = useCallback((route) => favorites.has(route), [favorites]);

  return { favorites, toggle, has };
}
